export default "__VITE_ASSET__CJs18$$Z__"